/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-extra-boolean-cast */
import { size } from 'lodash';
import { apiApp } from 'api/request';
import urlApp from 'api/urlApp';
import HttpRequestError from '../../utils/HttpRequetsError';

export async function getListMoneyStatisticAPI(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getListMoneyStatisticPath, {
    params: payload
  });
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getCusReconcilationAPI(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getCusReconcilationPath, {
    params: payload
  });
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getCusReconcilationPaymentAPI(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getCusReconcilationPaymentPath, {
    params: payload
  });
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}

export async function getCusReconcilationPaymentCountAPI(payload: any): Promise<any> {
  const {data} = await apiApp.get(urlApp.getCusReconcilationPaymentCountPath, {
    params: payload
  });
  if (size(data) >= 0) return data;
  throw new HttpRequestError(data.error, data.message);
}